import React, {useState} from 'react'
import { useFlutterwave } from 'react-flutterwave';
import  {paymentConfig} from '../../../utils/constants/payments/flutterwaveConfig'

export default function Donate() {
    var  _paymentConfig = paymentConfig;
    const handleFlutterPayment = useFlutterwave(_paymentConfig);
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [amount, setAmount] = useState(0)
    return (
        <section className="donate-form-section ptb-100">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="donate-form-content">
                        <h3>Do You Like To Help People Across The World?</h3>

                        <div className="donate-form-info">
                            <span>Or call us now</span>
                            <h4>(+256) 772-259323 </h4>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <form className="donate-form">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" name="name" className="form-control" placeholder="Your Full Name " onChange={e => setName(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <div className="select-box">
                                        <select className="form-control">
                                            <option value="5">Your Country</option>
                                            <option value="1">China</option>
                                            <option value="2">United Kingdom</option>
                                            <option value="0">Germany</option>
                                            <option value="3">France</option>
                                            <option value="4">Japan</option>
                                            
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="form-group">
                                <div className="form-group">
                                    <input type="text" name="email" className="form-control" placeholder="Your email" onChange={e => setEmail(e.target.value)}/>
                                </div>
                                    <div className="select-box">
                                        <select className="form-control" onChange={e => setAmount(e.target.value)}>
                                            <option value="400">$400</option>
                                            <option value="500">$500</option>
                                            <option value="600">$600</option>
                                            <option value="50">$50</option>
                                            <option value="1000">$1000</option>
                                            <option value="100">$100</option>
                                        </select>
                                        <span className="usd">$ USD</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="donate-form-btn">
                                    <a href="#" className="default-btn" onClick={
                                        () => {
                                            _paymentConfig.amount = amount;
                                            _paymentConfig.customer.email = email;
                                            _paymentConfig.customer.name = name;
                                            handleFlutterPayment({
                                              callback: (response) => {
                                                console.log(response);
                                              },
                                              onClose: () => {

                                              },
                                            });
                                        }
                                    }>
                                        Donate Your Money
                                        <span></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div className="donate-form-shape">
            <img src="assets/img/donate-form/shape.png" alt="Donate Shape"/>
        </div>
    </section>
    )
}
